import { render } from "./BlockStat.vue?vue&type=template&id=00d4c18e"
import script from "./BlockStat.vue?vue&type=script&lang=js"
export * from "./BlockStat.vue?vue&type=script&lang=js"

import "./BlockStat.vue?vue&type=style&index=0&id=00d4c18e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__